module.exports = __webpack_public_path__ + "components/flag/static/square/nc-2e35b5c45f0ee79d07ff1c37b3701da1.svg";